import * as React from 'react';
import { Modal, Button } from 'react-bootstrap'
import { DataHelper } from 'utils/DataHelper';
import { useNavigate } from "react-router-dom";
import { db } from 'utils/db'

export function ProductRow(props) {

    let navigate = useNavigate();

    let product = JSON.parse(props.item.contents);

    function productEdit () {
        navigate("/productedit", { state: { item: product } });
    }

    async function deleteProduct() {
        product.deleted = 1;
        await DataHelper.upload(product, db.products, product.productId, "product");
    }

    return (
        <div className="row product-row" key={product.tableGuid}>
            <div className="col-11" >
                <div className="product-type badge bg-dark not-onphone">{product.productType}</div>
                <div className="product-title" onClick={() => productEdit()} >{product.title} {product.isLocked ? <i className="bi bi-lock-fill"></i> : <></>}
                </div>
            </div>
            <div className="col-1">
                <button onClick={() => deleteProduct()} className="product-delete btn btn-delete btn-light"><i className="bi bi-trash"></i></button>
            </div>
        </div>
    );
}



/*
import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';


export class ReceptionRow extends Component {

    constructor(props) {
        super(props);

        this.state = { exhibitor: exhibitor };
        toggleCheckIn = toggleCheckIn.bind(this);
    }


    toggleCheckIn() {
        const exhibitor = this.state.exhibitor;
        const checkInDate = this.state.exhibitor.checkInDate ? null : new Date().toISOString();
        exhibitor.checkInDate = checkInDate;    //? :|||
        this.setState({ exhibitor: exhibitor })

        //-- save the change
        this.props.updateExhibitor(exhibitor);

    }



    render() {
        const exhibitor = this.state.exhibitor;

        return (
            <div className={exhibitor.checkedIn ? "row receptionRow checkedIn" : "row receptionRow"} key={ exhibitor.tableGuid } >
                <div className="col-md-12">
                    <div className="rebookCheckbox">
                        <div className="rebookNumber"><span className="rebookText">{exhibitor.rebookNumber}</span></div>
                        <div className="rebookNumberCheck">
                            {exhibitor.checkInDate && <Button variant="light" className="unchecked"><i className="bi bi-check-square" onClick={toggleCheckIn}></i></Button>  }
                            {!exhibitor.checkInDate && <Button variant="light" className="unchecked"><i className="bi bi-square" onClick={toggleCheckIn}></i></Button>}
                        </div>
                    </div>
                    <div className="rebookDetails">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="exhibitorName">{exhibitor.exhibitorName}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 exhibitorTime">12:30pm Today  <span style={{ marginLeft: "20px", fontWeight: "500" }}>Booth: {exhibitor.standNumber}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
*/